import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AgentModel } from 'src/app/models/agent.model';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { QRInput } from 'src/app/models/qr-input.model';
import { QRToggle } from 'src/app/models/qr-toggle.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RrhhDocumentTypesService } from 'src/app/services/rrhh/rrhh-document-types.service';
import { RrhhGetCitiesService } from 'src/app/services/rrhh/rrhh-get-cities.service';
import { RrhhGetCountriesService } from 'src/app/services/rrhh/rrhh-get-countries.service';
import { RrhhGetStatesService } from 'src/app/services/rrhh/rrhh-get-states.service';
import { RrhhValidationService } from 'src/app/services/rrhh/rrhh-validations.service';
import { UtilsService } from 'src/app/services/utils.service';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import { environment } from '@base/environments/environment';
import { QRTextarea } from '@base/src/app/models/qr-textarea.model';
import { Country, State, City } from '@base/src/app/models/address.model';
import { LocationGoogleAutocomplete } from '../../ubication-google/ubication-google.component';
import { QRInputAutocomplete } from '@base/src/app/models/qr-input-autocomplete.model';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-rrhh-info-form',
  templateUrl: './rrhh-info-form.component.html',
  styleUrls: ['./rrhh-info-form.component.scss'],
})
export class RrhhInfoFormComponent implements OnInit {
  @Input() data!: AgentModel;
  @Input() newFields:
    | { nationalities: string[]; educationLevels: string[] }
    | undefined;
  @Input() user:
    | { agencyId: number; isUy: boolean; loggedUser: string }
    | undefined;
  @Output() validStep: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() loadAgentData: EventEmitter<string> = new EventEmitter<string>();
  @Output() isTransfer: EventEmitter<boolean> = new EventEmitter<boolean>();

  errorUbicationGlobal = '';

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  readonly NODE_PY = Constants.TENANT_ID_PY;
  readonly NODE_DO = Constants.TENANT_ID_DO;
  readonly NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;
  readonly NICKNAME_MAX_LENGTH = 15;
  readonly NICKNAME_HINT = 'Solo letras y espacios, máx. 15 caracteres.';
  readonly NICKNAME_HINT_MAX = 'Alcanzaste el máximo de 15 caracteres.';

  dialogExamplePhoto: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '488px',
    title: 'Foto del agente',
    componentToLoad: QRDialog.DIALOG_RRHH_PHOTO_EXAMPLE,
    value: '',
  };

  dropdownDniType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Tipo',
    options: [],
  };

  dropdownCuitType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Tipo',
    options: ['CUIT', 'CUIL'],
  };

  dropdownInvoiceType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Tipo factura',
    options: ['Factura A', 'Factura B', 'Factura C'],
  };

  dropdownIvaCondition: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'IVA',
    options: ['Responsable Inscripto', 'Monotributista'],
  };

  dropdownCountry: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'País',
    options: [],
  };

  dropdownCity: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Ciudad',
    options: [],
  };

  dropdownStates: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Provincia',
    options: [],
  };

  inputDni: QRInput = {
    mode: QRInput.MODE_INTEGER,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese su número de documento',
    debounceTime: 500,
  };

  inputDniDO: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el número de identificación',
    debounceTime: 500,
    errorMsg: 'Ingrese un número válido como identificación',
  };

  //INPUT PARA N° DE IDENTIFICACION EN EC Y PY
  inputDniEC: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el número de identificación',
    debounceTime: 500,
    errorMsg: 'Ingrese un número válido como identificación',
  };

  inputName: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
    debounceTime: 500,
  };

  inputLastname: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Apellido',
    debounceTime: 500,
  };

  inputNickname: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Apodo',
    maxLength: this.NICKNAME_MAX_LENGTH,
    hint: this.NICKNAME_HINT,
    hintRight: `0/${this.NICKNAME_MAX_LENGTH}`,
    allowedPattern: /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]*$/,
  };

  inputUbication: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese una dirección',
    debounceTime: 500,
  };

  inputStreet: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese una calle',
    debounceTime: 500,
  };

  inputStreetNumber: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un número',
    debounceTime: 500,
  };

  inputZipCode: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el código postal',
    debounceTime: 500,
  };

  inputFloor: QRInput = {
    mode: QRInput.MODE_INTEGER,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el piso',
    debounceTime: 500,
  };

  inputApartment: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el departamento',
    debounceTime: 500,
  };

  inputEmail: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un email personal',
    debounceTime: 500,
  };

  inputCellphone: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un celular',
    debounceTime: 500,
  };

  inputPhone: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un teléfono',
    debounceTime: 500,
  };

  inputCuitFirst: QRInput = {
    mode: QRInput.MODE_INTEGER,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 500,
    maxLength: 2,
  };

  inputCuitMiddle: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 500,
    maxLength: 8,
  };

  inputCuitLast: QRInput = {
    mode: QRInput.MODE_INTEGER,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 500,
    maxLength: 1,
  };

  inputRazonSocial: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese la razón social',
    debounceTime: 500,
  };

  genderToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Femenino', 'Masculino'],
    optionSelected: 0,
  };

  dropdownCivilStatus: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccione',
    options: [],
  };

  dropdownEducationLevel: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccione',
    options: [],
  };

  buttonAddPhoto: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar foto',
    icon: Constants.ICONS.ADD_PHOTO,
  };

  autocompleteNationality: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Buscar nacionalidad',
    isCleanButtonVisible: true,
    options: [],
  };

  isManualEdit = false;

  cuit: { first: string; middle: string; last: string } = {
    first: '',
    middle: '',
    last: '',
  };

  defaultCoords: { lng: number; lat: number }[] = [
    { lng: -58.3815704, lat: -34.6037389 },
  ];
  defaultMapcenter = { lng: -58.3815704, lat: -34.6037389 };

  coords: { lng: number; lat: number }[] = [
    { lng: -58.3815704, lat: -34.6037389 },
  ];
  mapcenter = { lng: -58.3815704, lat: -34.6037389 };

  modeEditMap = false;
  isActiveMapDot = false;

  // VARIABLES SUBIDA FOTOS
  uploadedFileStatus = false; //==> El archivo se subió?
  uploadedFile: File | undefined; //==> archivo subido
  fileB64 = ''; //==> archivo en base64 para POST
  fileName = '';
  imagePath: SafeResourceUrl | undefined;
  photoErrorMessage: string = 'Agregue una foto';

  errors: {
    dniNumberFormat: boolean;
    documentType: boolean;
    dniValid: boolean;
    name: boolean;
    lastName: boolean;
    birthday: boolean;
    street: boolean;
    streetNumber: boolean;
    zipCode: boolean;
    floor: boolean;
    department: boolean;
    country: boolean;
    state: boolean;
    city: boolean;
    cellphone: boolean;
    phone: boolean;
    photo: boolean;
    tipoDoc: boolean;
    cuitFirst: boolean;
    cuitMiddle: boolean;
    cuitLast: boolean;
    fcDeskFee: boolean;
    fcCondition: boolean;
    fullAdress: boolean;
    email: boolean;
    dniNumber: boolean;
    coords: boolean;
    razonSocial: boolean;
    quantityChildren: boolean;
    nationality: boolean;
    [key: string]: boolean;
  } = {
    dniNumberFormat: false,
    documentType: false,
    dniValid: false,
    name: false,
    lastName: false,
    birthday: false,
    street: false,
    streetNumber: false,
    zipCode: false,
    floor: false,
    department: false,
    country: false,
    state: false,
    city: false,
    cellphone: false,
    phone: false,
    photo: false,
    tipoDoc: false,
    cuitFirst: false,
    cuitMiddle: false,
    cuitLast: false,
    fcDeskFee: false,
    fcCondition: false,
    fullAdress: true,
    email: false,
    dniNumber: false,
    coords: false,
    razonSocial: false,
    quantityChildren: false,
    nationality: false,
  };

  warnings: { phone: boolean } = {
    phone: false,
  };

  dniMessage: string = '';
  showDniResult = false;
  loadingDni = false;

  fcDeskFee = '';
  fcCondition = '';
  tipoDoc = '';

  countries: Country[] = [];
  states: State[] = [];
  cities: City[] = [];

  nationality = '';
  quantityChilds = 0;
  educationLevel = '';

  allowedFormats = [
    // Documentos de Word
    // 'application/msword',
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

    // Documentos de PDF
    // 'application/pdf',

    // Archivos de texto
    // 'text/plain',

    // Archivos de hoja de cálculo
    // 'application/vnd.ms-excel',
    // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

    // Imágenes
    'image/jpeg',
    'image/jpg',
    'image/png',
  ];

  inputBirthdate: QRDatePicker = {
    errorMsg: 'Ingrese una fecha correcta',
    maxDate: '2023-10-25',
    isDisplayedUp: true,
  };

  textarea: QRTextarea = {
    icon: Constants.ICONS.DESCRIPTION,
    placeholder: 'Ingrese observación',
  };

  textareaValue: string | undefined =
    'Ejemplo de la observación pública que contiene este agente.';

  private readonly ERROR_LABELS: Record<string, string> = {
    street: 'calle',
    streetNumber: 'número',
    zipCode: 'código postal',
    city: 'ciudad',
    state: 'provincia',
    country: 'país',
    coords: 'coordenadas',
  };

  constructor(
    private readonly rrhhDocumentTypes: RrhhDocumentTypesService,
    private readonly rrhhValidationService: RrhhValidationService,
    private readonly rrhhGetCountriesService: RrhhGetCountriesService,
    private readonly rrhhGetStatesService: RrhhGetStatesService,
    private readonly rrhhGetCitiesService: RrhhGetCitiesService,
    private readonly _sanitizer: DomSanitizer,
    public utilsService: UtilsService,
  ) {}

  ngOnInit(): void {
    this.setCivilStatusOptions();
    this.defaultCoordsMap();

    if (!this.data.tipoDoc && this.NODE !== this.NODE_DO) {
      this.errors.tipoDoc = false;
      this.data.tipoDoc = 80;
      this.tipoDoc = 'CUIT';
    }

    if (!this.data.fcDeskFee && this.NODE !== this.NODE_DO) {
      this.errors.fcDeskFee = false;
      this.data.fcDeskFee = '1';
      this.fcDeskFee = 'Factura A';
    }

    if (this.data.documentNumber) {
      this.showDniResult = true;
      this.errors.dniValid = false;
      this.dniMessage =
        'Se encontraron datos del agente. Validar antes de guardar';
    } else {
      // Si no cuenta con n° de documento estamos creando y activamos flag de error de tipo de doc
      this.errors.documentType = true;
    }

    if (this.data.id) {
      this.dniMessage = '';
      this.showDniResult = true;
      this.coords = [
        {
          lng: this.data.longitude ?? 0,
          lat: this.data.latitude ?? 0,
        },
      ];
      this.mapcenter = {
        lng: this.data.longitude ?? 0,
        lat: this.data.latitude ?? 0,
      };
      this.formatData();
    }

    if (this.data.civilStatus) {
      this.data.civilStatus = this.data.civilStatus.toUpperCase();
    }

    this.NODE === this.NODE_DO ? this.formatAddressDO() : this.getCountries();

    this.getDocumentTypes();
    this.setBirthdateConfig();

    if (this.NODE === this.NODE_DO && !this.nationality) {
      this.errors.nationality = true;
    }

    this.updateNicknameHints(this.data.nickname);
  }

  formatAddressDO() {
    if (this.data.fullAdress) {
      this.errors.fullAdress = false;
      this.errors.country = false;
      this.errors.state = false;
      this.errors.city = false;
      this.errors.street = false;
      this.errors.streetNumber = false;
      this.errors.zipCode = false;
    }
  }

  formatEducationLevels() {
    this.dropdownEducationLevel.options = this.newFields?.educationLevels ?? [];
  }

  formatNationalities() {
    this.autocompleteNationality = {
      ...this.autocompleteNationality,
      options: this.newFields?.nationalities ?? [],
    };
  }

  setCivilStatusOptions(): void {
    const OPTIONS_BASE = ['Soltero', 'Casado', 'Divorciado', 'Viudo'];

    this.dropdownCivilStatus.options =
      this.NODE === this.NODE_DO
        ? [...OPTIONS_BASE, 'Union libre']
        : [...OPTIONS_BASE, 'Union de hecho'];
  }

  //Se definen coordenadas default segun la región
  defaultCoordsMap() {
    let lng = 0;
    let lat = 0;

    switch (this.NODE) {
      case this.NODE_AR:
        lat = -34.6037389;
        lng = -58.3815704;
        break;

      case this.NODE_EC:
        lat = -0.176706;
        lng = -78.481011;
        break;

      case this.NODE_PY:
        lat = -25.2912258;
        lng = -57.6556819;
        break;

      default:
        lat = -34.6037388;
        lng = -58.3815705;
        break;
    }
    const finalCoords = { lng: lng, lat: lat };

    this.defaultCoords = [finalCoords];
    this.defaultMapcenter = finalCoords;
    this.coords = [finalCoords];
    this.mapcenter = finalCoords;
  }

  formatData() {
    if (this.data.photo) this.imagePath = this.data.photo;
    if (this.data.fullAdress) this.errors.fullAdress = false;

    if (this.NODE === this.NODE_AR) {
      if (this.data.cuit) this.generateCuit();
      if (this.data.fcDeskFee) this.generateDeskFee();
      if (this.data.fcCondition) this.generateFcCondition();
      if (this.data.tipoDoc) this.generateTipoDoc();
    }

    if (
      this.NODE === this.NODE_DO &&
      this.data.agentProfileFieldValues &&
      this.data.agentProfileFieldValues.length > 0
    ) {
      this.data.agentProfileFieldValues.forEach(
        (item: { fieldId: number; value: string }) => {
          if (item.fieldId === 1) this.nationality = item.value;
          if (item.fieldId === 2) this.quantityChilds = Number(item.value);
          if (item.fieldId === 3) this.educationLevel = item.value;
        },
      );
    }

    this.validateFields();
    this.updateNicknameHints(this.data.nickname);
  }

  ngOnChanges() {
    if (this.data.genre != 'F') this.genderToggle.optionSelected = 1;
    if (this.data.latitude && this.data.longitude) {
      this.mapcenter = { lng: this.data.longitude, lat: this.data.latitude };
      this.coords = [{ lng: this.data.longitude, lat: this.data.latitude }];
    }
    if (this.NODE_DO === this.NODE) {
      this.formatEducationLevels();
      this.formatNationalities();
    }
    this.formatData();
  }

  getDocumentTypes() {
    this.rrhhDocumentTypes.get('').then((response: any) => {
      if (response?.data?.documentTypes) {
        response.data.documentTypes.forEach((e: any) => {
          this.dropdownDniType.options.push(e.id);
        });
      }
    });
  }

  changeInputDni($event: InputTypes) {
    if ($event && $event.toString() != this.data.documentNumber) {
      this.showDniResult = false;
      this.errors.dniNumber = true;
      if (Number($event) > 999999 && Number($event) < 999999999999) {
        this.loadingDni = true;
        this.data.documentNumber = $event?.toString();
        this.validateDniNumber(this.data.documentNumber);
        this.errors.dniNumber = false;
      }
    }
  }

  changeInputDniDO(event: InputTypes): void {
    if (!event) return;

    const VALUE = event.toString().trim();
    if (VALUE === this.data.documentNumber) return;

    this.showDniResult = false;
    this.errors.dniNumber = true;
    this.errors.dniValid = false;

    let isValid = false;
    let errorMessage = '';

    switch (this.data.documentType) {
      case 'CED':
        isValid = /^\d{11}$/.test(VALUE);
        errorMessage = 'La cédula debe tener exactamente 11 números.';
        break;

      case 'RNC':
        isValid = /^\d{6,11}$/.test(VALUE);
        errorMessage = 'El RNC debe tener entre 6 y 11 números.';
        break;

      case 'PAS':
        isValid = /^[a-zA-Z0-9]{1,13}$/.test(VALUE);
        errorMessage =
          'El pasaporte debe tener hasta 13 caracteres alfanuméricos.';
        break;
    }

    if (!isValid) {
      this.inputDniDO.errorMsg = errorMessage;
      this.inputDniDO = { ...this.inputDniDO };
      this.loadingDni = false;
      this.errors.dniValid = true;
      this.dniMessage = errorMessage;
      return;
    }

    this.loadingDni = true;
    this.data.documentNumber = VALUE;
    this.errors.dniNumber = false;
    this.errors.dniValid = false;
    this.validateDniNumber(VALUE);
  }

  changeInputDniEC($event: InputTypes) {
    const value = $event?.toString() ?? '';
    const isDifferentNumber = value != this.data.documentNumber;

    if (isDifferentNumber) {
      // \d es digitos del 0 al 9
      const FORMAT_PY = /^\d{6,8}$/;
      const FORMAT_EC = /^\d{8,10}$/;
      const FORMAT_GLOBAL = /^[\dA-Za-z.-]{7,13}$/;
      let isValidNumber = false;
      this.data.documentNumber = value;

      switch (this.NODE) {
        case this.NODE_EC:
          isValidNumber = FORMAT_EC.test(value);
          break;
        case this.NODE_PY:
          isValidNumber = FORMAT_PY.test(value);
          break;
        case this.NODE_GLOBAL:
          isValidNumber = FORMAT_GLOBAL.test(value);
      }

      this.errors.dniValid = false;
      this.showDniResult = !(value && isValidNumber);
      this.loadingDni = !!value && isValidNumber;
      this.errors.dniNumber = !(value && isValidNumber);

      if (value && isValidNumber)
        this.validateDniNumber(this.data.documentNumber);
    }
  }

  changeDniType($event: string) {
    this.errors.documentType = true;

    if (this.NODE === this.NODE_DO) {
      this.data.documentNumber = '';
      this.errors.dniNumber = true;
      this.showDniResult = false;
    }

    if ($event) {
      this.data.documentType = $event;
      this.errors.documentType = false;
    }

    this.validateFields();
  }

  changeInputName($event: InputTypes) {
    this.errors.name = true;
    if ($event && $event.toString().length <= 30) {
      const input = $event.toString();
      this.data.name = input;
      this.errors.name = /[^a-zñáéíóúüA-ZÁÉÍÓÚ 0123456789']/.test(input);
    }
    this.validateFields();
  }

  changeInputLastName($event: InputTypes) {
    this.errors.lastName = true;
    if ($event && $event.toString().length <= 30) {
      const input = $event.toString();
      this.data.lastName = input;
      this.errors.lastName = /[^a-zñáéíóúüA-ZÁÉÍÓÚ 0123456789']/.test(input);
    }
    this.validateFields();
  }

  changeInputNickname($event: InputTypes): void {
    const VALUE = $event == null ? '' : $event.toString();
    this.data.nickname = VALUE;
    this.updateNicknameHints(VALUE);
  }

  updateNicknameHints(value?: string | null): void {
    const LENGTH = value ? value.toString().length : 0;
    this.inputNickname.hintRight = `${LENGTH}/${this.NICKNAME_MAX_LENGTH}`;
    this.inputNickname.hint =
      LENGTH >= this.NICKNAME_MAX_LENGTH
        ? this.NICKNAME_HINT_MAX
        : this.NICKNAME_HINT;
  }

  onChangeGender($event: number) {
    this.data.genre = 'F';
    if ($event == 1) this.data.genre = 'M';
  }

  changeCivilStatus($event: string) {
    this.data.civilStatus = $event.toUpperCase();
  }

  fillAddressFields(googleData: LocationGoogleAutocomplete) {
    this.data.country = googleData.country ?? null;
    this.errors.country = !this.data.country;

    this.data.state =
      (googleData.state == 'Ciudad Autónoma de Buenos Aires'
        ? 'Capital Federal'
        : googleData.state) ?? null;
    this.errors.state = !this.data.state;

    this.data.city =
      (googleData.state == 'Ciudad Autónoma de Buenos Aires'
        ? googleData.neighborhood
        : googleData.city) ?? null;

    this.errors.city = !this.data.city;

    this.data.streetNumber = googleData.street_number?.toString() ?? null;
    this.errors.streetNumber =
      this.NODE === this.NODE_DO ? false : !this.data.streetNumber;

    this.data.street = googleData.street_name ?? null;
    this.errors.street = !this.data.street;

    this.data.zipCode = googleData.postal_code?.toString() ?? null;
    this.errors.zipCode =
      this.NODE === this.NODE_DO ? false : !this.data.zipCode;

    this.data.fullAdress = googleData.display_address ?? null;
    this.errors.fullAdress = !this.data.fullAdress;

    this.data.latitude = googleData.lat;
    this.data.longitude = googleData.lng;

    this.errors.coords = !(this.data.longitude && this.data.latitude);

    const COORDS = { lng: this.data.longitude, lat: this.data.latitude };

    this.coords = [COORDS];
    this.mapcenter = COORDS;

    const REQUIRE_STREET_NUMBER = this.NODE !== this.NODE_DO;
    const REQUIRE_ZIP_CODE = this.NODE !== this.NODE_DO;

    const FILTERED_ERRORS = {
      street: this.errors.street,
      streetNumber: REQUIRE_STREET_NUMBER ? this.errors.streetNumber : false,
      zipCode: REQUIRE_ZIP_CODE ? this.errors.zipCode : false,
      city: this.errors.city,
      state: this.errors.state,
      country: this.errors.country,
    };

    // Mensaje dinámico según campo faltante
    this.errorUbicationGlobal =
      (this.NODE === this.NODE_GLOBAL || this.NODE === this.NODE_DO) &&
      Object.values(FILTERED_ERRORS).some((e) => e === true)
        ? this.buildErrorMessage(FILTERED_ERRORS)
        : '';

    // Simulo un click para que se actualice el componente de ubicacion
    setTimeout(() => {
      const ELEMENT = document.getElementById('rrhh-info-container');
      if (ELEMENT) {
        ELEMENT.click();
      }
    }, 1);
  }

  private buildErrorMessage(errors: any): string {
    const FIELDS_WITH_ERROR = Object.keys(errors)
      .filter((key) => errors[key] === true)
      .map((key) => this.ERROR_LABELS[key])
      .filter(Boolean);

    if (!FIELDS_WITH_ERROR.length) return '';

    return `
        Complete la ubicación. Se requiere: ${FIELDS_WITH_ERROR.join(', ')}.`;
  }

  setAddress(googleData: LocationGoogleAutocomplete, map: HTMLElement) {
    if (!googleData) {
      this.errors.fullAdress = true;

      if (this.NODE === this.NODE_DO) {
        this.errorUbicationGlobal =
          'Complete la ubicación. Se requiere calle, ciudad, provincia y país';
      } else {
        this.errorUbicationGlobal =
          'Complete la ubicación. Se requiere calle, número, código postal, ciudad, provincia y país';
      }

      return;
    }

    if (!this.isManualEdit) {
      this.errors.fullAdress = true;
      if (googleData) {
        this.fillAddressFields(googleData);
        if (this.NODE !== this.NODE_GLOBAL && this.NODE !== this.NODE_DO) {
          this.fillCountry(); // Intenta completar los ids de country, state y city
          if (map) {
            map.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'start',
            });
          }
        }
        this.errors.fullAdress = false;
      }
    }
    this.validateAddress();
  }

  changeInputStreet($event: InputTypes) {
    this.errors.street = true;
    this.data.street = '';
    if ($event) {
      this.data.street = $event.toString();
      this.errors.street = false;
    }
    this.validateAddress();
    this.validateFields();
  }

  changeInputStreetNumber($event: InputTypes) {
    this.errors.streetNumber = true;
    if ($event) {
      this.data.streetNumber = $event.toString();
      this.errors.streetNumber = false;
    } else {
      this.data.streetNumber = '';
    }
    this.validateAddress();
    this.validateFields();
  }

  changeInputZipCode($event: InputTypes) {
    this.errors.zipCode = true;
    this.data.zipCode = $event?.toString() ?? '';
    if ($event) {
      this.errors.zipCode = false;
    }
    this.validateAddress();
    this.validateFields();
  }

  changeInputFloor($event: InputTypes) {
    this.data.floor = $event?.toString();
    this.validateFields();
  }

  changeInputApartment($event: InputTypes) {
    this.data.department = $event?.toString();
    this.validateFields();
  }

  changeInputEmail($event: InputTypes) {
    this.errors.email = true;
    if ($event && $event.toString().length < 50) {
      const filter = /^\s*[\w-+]+(\.[\w-+]+)*@[\w-+]+\.[\w-+]+(\.[\w-+]+)*\s*$/;
      this.data.email = $event.toString().toLowerCase();
      this.errors.email = this.data.email.search(filter) == -1;
    }
    this.validateFields();
  }

  changeInputCellphone($event: InputTypes) {
    this.errors.cellphone = true;
    if ($event) {
      const INPUT = $event?.toString();
      if (INPUT && INPUT.length > 8 && INPUT.length < 20) {
        this.data.cellphone = INPUT;
        this.errors.cellphone = !/^\+?\(?\d{1,3}\)?[-\d()]*$/.test(
          this.data.cellphone,
        );
      }
    }
    this.validateFields();
  }

  changeInputCellphoneDO($event: InputTypes) {
    this.errors.cellphone = true;
    if ($event) {
      const INPUT = $event?.toString();
      if (INPUT && INPUT.length >= 10 && INPUT.length <= 15) {
        const REGEX = /^\+1\(?\d{1,3}\)?[-\d()]*$/;
        if (REGEX.test(INPUT)) {
          this.data.cellphone = INPUT;
          this.errors.cellphone = false;
        }
      }
    }
    this.validateFields();
  }

  changeInputPhone($event: InputTypes) {
    this.warnings.phone = true;
    if ($event) {
      const input = $event?.toString();
      if (input && input.length > 8 && input.length < 20) {
        this.data.phone = input;
        this.warnings.phone = !/^\+?\(?\d{1,3}\)?[-\d()]*$/.test(
          this.data.phone,
        );
      }
    } else {
      this.data.phone = '';
    }
    this.validateFields();
  }

  changeInputPhoneDO($event: InputTypes) {
    this.warnings.phone = true;
    const INPUT = $event?.toString();
    if (INPUT && INPUT.length >= 10 && INPUT.length <= 15) {
      const REGEX = /^\+1\(?\d{1,3}\)?[-\d()]*$/;
      if (REGEX.test(INPUT)) {
        this.data.phone = INPUT;
        this.warnings.phone = false;
        this.errors.phone = false;
      }
    } else {
      this.data.phone = '';
      this.errors.phone = false;
      this.warnings.phone = false;
    }

    this.validateFields();
  }

  changeCuitType($event: string) {
    this.errors.tipoDoc = true;
    if (this.user?.isUy) this.errors.tipoDoc = false;
    if ($event) {
      this.data.tipoDoc = 80;
      if ($event == 'CUIL') this.data.tipoDoc = 86;
      this.errors.tipoDoc = false;
    }
    this.validateFields();
  }

  changeInputCuitFirst($event: InputTypes) {
    this.errors.cuitFirst = true;
    if (this.user?.isUy) this.errors.cuitFirst = false;
    if ($event) {
      const input = $event.toString();
      if (input.length == 2) {
        this.cuit.first = input;
        this.errors.cuitFirst = false;
      }
    }
    this.formatCuit();
    this.validateFields();
  }

  changeInputCuitMiddle($event: InputTypes) {
    this.errors.cuitMiddle = true;
    if (this.user?.isUy) this.errors.cuitMiddle = false;
    if ($event) {
      const input = $event.toString();
      if (input.length == 8) {
        this.cuit.middle = input;
        this.errors.cuitMiddle = false;
      }
    }
    this.formatCuit();
    this.validateFields();
  }

  changeInputCuitLast($event: InputTypes) {
    this.errors.cuitLast = true;
    if (this.user?.isUy) this.errors.cuitLast = false;
    if ($event || $event === 0) {
      const input = $event.toString();
      if (input.length == 1) {
        this.cuit.last = input;
        this.errors.cuitLast = false;
      }
    }
    this.formatCuit();
    this.validateFields();
  }

  formatCuit() {
    if (this.cuit.first && this.cuit.middle && this.cuit.last)
      this.data.cuit = this.cuit.first + this.cuit.middle + this.cuit.last;
  }

  changeInputRazonSocial($event: InputTypes) {
    this.errors.razonSocial = true;
    if (this.user?.isUy) this.errors.razonSocial = false;
    if ($event) {
      this.data.razonSocial = $event.toString();
      this.errors.razonSocial = false;
    }
    this.validateFields();
  }

  changeInvoiceType($event: string) {
    this.errors.fcDeskFee = true;
    if (this.user?.isUy) this.errors.fcDeskFee = false;
    if ($event) {
      switch ($event) {
        case 'Factura A':
          this.data.fcDeskFee = '1';
          break;
        case 'Factura B':
          this.data.fcDeskFee = '6';
          break;
        case 'Factura C':
          this.data.fcDeskFee = '11';
          break;
      }
      this.errors.fcDeskFee = false;
    }
    this.validateFields();
  }

  changeIvaCondition($event: string) {
    this.errors.fcCondition = true;
    if (this.user?.isUy) this.errors.fcCondition = false;
    if ($event) {
      switch ($event) {
        case 'Responsable Inscripto':
          this.data.fcCondition = '1';
          break;
        case 'Consumidor Final':
          this.data.fcCondition = '5';
          break;
        case 'Monotributista':
          this.data.fcCondition = '6';
          break;
      }
      this.errors.fcCondition = false;
    }
    this.validateFields();
  }

  openDialogExample() {
    this.dialogExamplePhoto = { ...this.dialogExamplePhoto, isVisible: true };
  }

  validateDniNumber(number: string) {
    this.showDniResult = false;
    this.rrhhValidationService
      .get(number + '/' + this.user?.agencyId)
      .then((response: any) => {
        this.loadingDni = false;
        if (response?.code == 200 && response?.data) {
          this.isTransfer.emit(response.data.transfer);
          if (response.data.available && response.data.id) {
            this.dniMessage = response.message;
            this.loadAgentData.emit(response.data.id);
            this.showDniResult = true;
            this.errors.dniValid = false;
            this.dniMessage =
              'Se encontraron datos del agente. Validar antes de guardar';
          } else if (!response.data.available && !response.data.id) {
            this.dniMessage = response.message;
            this.showDniResult = true;
            this.errors.dniValid = true;
          } else if (response.data.available && !response.data.id) {
            this.showDniResult = true;
            this.dniMessage = response.message;
            this.errors.dniValid = false;
          } else if (this.errors.dniValid) {
            this.data.documentNumber = '';
          }
        }
      });
  }

  getCountries() {
    this.countries = [];
    this.dropdownCountry.options = [];
    this.rrhhGetCountriesService.get('').then((response: any) => {
      if (response?.data?.countries) {
        response.data.countries.forEach((e: Country) => {
          this.countries.push(e);
          this.dropdownCountry.options.push(e.name);
        });
        this.fillCountry();
      }
    });
  }

  getStates() {
    if (this.data.countryId) {
      this.states = [];
      this.dropdownStates.options = [];
      this.rrhhGetStatesService
        .get(this.data.countryId)
        .then((response: any) => {
          if (response?.data?.provinces) {
            response.data.provinces.forEach((e: State) => {
              this.states.push(e);
              this.dropdownStates.options.push(e.name);
            });
            this.fillStates();
          }
        });
    }
  }

  getCities() {
    if (this.data.stateId) {
      this.cities = [];
      this.dropdownCity.options = [];
      this.rrhhGetCitiesService.get(this.data.stateId).then((response: any) => {
        if (response?.data?.city) {
          response.data.city.forEach((e: City) => {
            this.cities.push(e);
            this.dropdownCity.options.push(e.name);
          });
          this.fillCities();
        }
      });
      if (this.data.stateId == 'AR-01') {
        this.rrhhGetCitiesService.get('AR-02').then((response: any) => {
          if (response?.data?.city) {
            response.data.city.forEach((e: City) => {
              this.cities.push(e);
              this.dropdownCity.options.push(e.name);
            });
            this.fillCities();
          }
        });
      }
    }
  }

  changeCountry($event: string) {
    this.errors.country = true;
    if ($event) {
      this.data.country = $event;
      this.fillCountry();
      this.validateAddress();
      this.errors.country = false;
    }
  }

  changeState($event: string) {
    this.errors.state = true;
    if ($event) {
      this.data.state = $event;
      this.fillStates();
      this.validateAddress();
      this.errors.state = false;
    }
  }

  changeCity($event: string) {
    this.errors.city = true;
    if ($event) {
      this.data.city = $event;
      this.errors.city = false;
      this.fillCities();
      this.validateAddress();
    }
  }

  fillCountry() {
    if (this.data.country && this.countries.length > 0) {
      const FIND = this.countries.find(
        (item: Country) => item.name == this.data.country,
      );
      if (FIND) this.data.countryId = FIND.id;
      this.getStates();
    }
  }

  fillStates() {
    if (this.data.state && this.states.length > 0) {
      const FIND = this.states.find(
        (item: State) => item.name == this.data.state,
      );
      if (FIND) {
        this.data.stateId = FIND.id;
        this.getCities();
      }
    }
  }

  fillCities() {
    this.dropdownCity.options.sort((a: string, b: string) =>
      a.toLowerCase() > b.toLowerCase() ? 1 : -1,
    );
    if (this.data.city && this.cities.length > 0) {
      const FIND = this.cities.find(
        (item: City) => item.name == this.data.city,
      );
      if (FIND) {
        this.data.cityId = FIND.id;
      }
    }
  }

  getImgDimensions(
    file: File,
  ): Promise<{ width: number; height: number; file: File }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const img = new Image();
        img.src = event?.target?.result as string;
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          resolve({ width, height, file });
        };
      };
      reader.readAsDataURL(file);
    });
  }

  async addFile($event: any) {
    this.errors.photo = false;
    const reader = new FileReader();
    this.photoErrorMessage = 'Se produjo un error en la subida de la imagen.';
    let isValidDimension = false;

    if ($event.target.files) {
      this.uploadedFile = $event.target.files[0];

      await this.getImgDimensions($event.target.files[0]).then((dimensions) => {
        isValidDimension = dimensions.height <= 600 && dimensions.width <= 600;
      });

      // Validacion tipo de archivo
      if (
        this.uploadedFile &&
        !this.allowedFormats.includes(this.uploadedFile.type)
      ) {
        this.photoErrorMessage = 'Formato de imagen no soportado.';
        this.errors.photo = true;

        // Validacion tamaño de archivo
      } else if (
        this.uploadedFile &&
        this.uploadedFile.size > 2 * 1024 * 1024
      ) {
        this.photoErrorMessage = 'Tamaño de imagen superior a 2 MB.';
        this.errors.photo = true;
      } else if (!isValidDimension) {
        this.photoErrorMessage =
          'Tamaño de imagen superior a 600 x 600 píxeles.';
        this.errors.photo = true;
      } else {
        this.fileName = this.uploadedFile
          ? this.utilsService.sanitizeFileName(this.uploadedFile.name)
          : '';
        reader.onloadend = () => {
          const result = reader.result as string;
          this.fileB64 = result;
          this.data.photo = result;
          this.imagePath =
            this._sanitizer.bypassSecurityTrustResourceUrl(result);
          this.errors.photo = false;
          this.validateFields();
        };

        if (this.uploadedFile) {
          reader.readAsDataURL(this.uploadedFile);
          this.uploadedFileStatus = true;
        }
        this.validateFields();
      }
    }
  }

  validateAddress() {
    if (this.NODE === this.NODE_GLOBAL || this.NODE === this.NODE_DO) {
      this.validateFields();
      return;
    }

    const REQUIRED_FIELDS = [
      'street',
      'streetNumber',
      'zipCode',
      'country',
      'state',
      'city',
    ];

    REQUIRED_FIELDS.forEach((field: string) => {
      if (!this.data[field]) {
        this.errors[field] = true;
      }
    });

    if (this.isManualEdit) {
      this.generateFullAddressPretty();
    }

    if (!this.data.fullAdress) {
      this.errors.fullAdress = true;
    }
    this.validateFields();
  }

  validateArg() {
    const OPTIONALS = [
      'department',
      'floor',
      'photo',
      'dniValid',
      'fullAdress',
      'phone',
    ];

    Object.keys(this.data).forEach((key: any) => {
      if (!OPTIONALS.includes(key)) {
        if (!this.data[key] && this.errors.hasOwnProperty(key)) {
          this.errors[key] = true;
        }
        if (!this.cuit.first) this.errors.cuitFirst = true;
        if (!this.cuit.middle) this.errors.cuitMiddle = true;
        if (!this.cuit.last) this.errors.cuitLast = true;
      }
    });
  }

  validateUy() {
    const OPTIONALS = [
      'department',
      'floor',
      'photo',
      'dniValid',
      'fullAdress',
      'phone',
      'tipoDoc',
      'razonSocial',
      'fcDeskFee',
      'fcCondition',
    ];

    Object.keys(this.data).forEach((key: any) => {
      if (!OPTIONALS.includes(key)) {
        if (!this.data[key] && this.errors.hasOwnProperty(key)) {
          this.errors[key] = true;
        }
      }
    });
  }

  validateDO() {
    const REQUIRED_DO = [
      'documentType',
      'name',
      'lastName',
      'birthday',
      'email',
      'cellphone',
      'fullAdress',
    ];

    REQUIRED_DO.forEach((key) => {
      if (!this.data[key]) {
        this.errors[key] = true;
      }
    });

    if (!this.data.phone) {
      this.errors.phone = false;
      this.warnings.phone = false;
    }

    this.errors.nationality = !this.nationality?.trim();
  }

    validatePy() {
    const OPTIONALS = [
      'department',
      'floor',
      'photo',
      'dniValid',
      'fullAdress',
      'phone',
    ];

    Object.keys(this.data).forEach((key: any) => {
      if (!OPTIONALS.includes(key)) {
        if (!this.data[key] && this.errors.hasOwnProperty(key)) {
          this.errors[key] = true;
        }
      }
    });
  }

  validateFields() {
    if (this.NODE === this.NODE_AR) {
      this.user?.isUy ? this.validateUy() : this.validateArg();
    } else if (this.NODE === this.NODE_DO) {
      this.validateDO();
    } else if (this.NODE === this.NODE_PY) {
      this.validatePy();
    }

    //Ecuador, Paraguay y Global no tienen facturación
    const NO_BILLING = [
      this.NODE_EC,
      this.NODE_DO,
      this.NODE_PY,
      this.NODE_GLOBAL,
    ];
    if (NO_BILLING.includes(this.NODE)) {
      this.errors.cuitFirst = false;
      this.errors.cuitMiddle = false;
      this.errors.cuitLast = false;
      this.errors.razonSocial = false;
      this.errors.tipoDoc = false;
      this.errors.fcCondition = false;
      this.errors.fcDeskFee = false;
    }

    let result = true;
    Object.keys(this.errors).forEach((key: string) => {
      result = result && !this.errors[key];
    });

    this.validStep.emit(result);
  }

  generateCuit() {
    this.cuit.first = this.data.cuit.slice(0, 2);
    this.cuit.middle = this.data.cuit.slice(2, 10);
    this.cuit.last = this.data.cuit.slice(10, 11);
    if (this.data.cuit) {
      this.errors.cuitFirst = false;
      this.errors.cuitMiddle = false;
      this.errors.cuitLast = false;
    }
    this.validateFields();
  }

  generateDeskFee() {
    switch (this.data.fcDeskFee) {
      case '1':
        this.fcDeskFee = 'Factura A';
        break;
      case '6':
        this.fcDeskFee = 'Factura B';
        break;
      case '11':
        this.fcDeskFee = 'Factura C';
        break;
    }
    this.validateFields();
  }

  generateFcCondition() {
    switch (this.data.fcCondition) {
      case '1':
        this.fcCondition = 'Responsable Inscripto';
        break;
      case '5':
        this.fcCondition = 'Consumidor Final';
        break;
      case '6':
        this.fcCondition = 'Monotributista';
        break;
    }
    this.validateFields();
  }

  generateTipoDoc() {
    if (this.data.tipoDoc == 80) this.tipoDoc = 'CUIT';
    if (this.data.tipoDoc == 86) this.tipoDoc = 'CUIL';
  }

  manualEditChanged(e: any): void {
    this.isManualEdit = e.checked;
    if (this.isManualEdit) {
      this.errors.coords = true;
      this.errors.fullAdress = false;
      this.data.latitude = null;
      this.data.longitude = null;
    } else {
      this.data.fullAdress = '';
      this.coords = this.defaultCoords;
      this.mapcenter = this.defaultMapcenter;
      this.errors.coords = false;
      this.errors.fullAdress = true;
    }
  }

  onclickmap(coordsData: any): void {
    const lat = coordsData.lat.toFixed(7);
    const lng = coordsData.lng.toFixed(7);
    if (this.isManualEdit && this.isActiveMapDot) {
      this.coords = [
        {
          lng: lng,
          lat: lat,
        },
      ];
      this.data.latitude = lat;
      this.data.longitude = lng;
      this.mapcenter = {
        lng: this.data.longitude ?? 0,
        lat: this.data.latitude ?? 0,
      };
      this.errors.coords = false;
    }
  }

  onClickMarkerMap() {
    if (this.isManualEdit) {
      this.isActiveMapDot = !this.isActiveMapDot;
      if (this.isActiveMapDot) {
        this.data.latitude = null;
        this.data.longitude = null;
        this.errors.coords = true;
      }
    }
  }

  generateFullAddressPretty() {
    let string = '';
    if (this.data.street) string += this.data.street + ' ,';
    if (this.data.streetNumber && this.data.street)
      string = this.data.street + ' ' + this.data.streetNumber + ', ';
    if (this.data.zipCode) string += this.data.zipCode + ', ';
    if (this.data.city) string += this.data.city + ', ';
    if (this.data.state) string += this.data.state + ', ';
    if (this.data.country) string += this.data.country;
    this.data.fullAdress = string;
  }

  isValidDecimalNumber(e: KeyboardEvent): void {
    // Excepciones
    if (
      (e.key === 'a' && e.ctrlKey === true) || // Permitir: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Permitir: Ctrl+C
      (e.key === 'x' && e.ctrlKey === true) || // Permitir: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Permitir+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Permitir: Cmd+C (Mac)
      (e.key === 'x' && e.metaKey === true) || // Permitir: Cmd+X (Mac)
      e.key === 'Tab' || // Permitir: Tab
      e.key === 'Backspace' || // Permitir: Backspace
      e.key === 'Delete' || // Permitir: Delete
      e.key === 'ArrowLeft' || // Permitir: Flecha a la izquierda
      e.key === 'ArrowRight' // Permitir: Flecha a la derecha
    ) {
      return; // dejar que pase, no hago nada
    }

    // Asegurarse que es un número valido
    if (e.key === ' ' || isNaN(Number(e.key))) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  }

  setBirthdateConfig(): void {
    const MAXIMUM_VALID_DATE: string = moment()
      .subtract(18, 'years')
      .format('YYYY-MM-DD'); // Fecha actual menos 18 años, solo se permite seleccionar fechas de nacimiento de personas mayores a 18 años
    this.inputBirthdate = {
      ...this.inputBirthdate,
      maxDate: MAXIMUM_VALID_DATE, // Fecha limite permitida
    };
    if (this.data.birthday) {
      this.inputBirthdate = {
        ...this.inputBirthdate,
        date: this.data.birthday, // Cargar fecha de nacimiento ya definida
      };
    }
  }

  inputBirthdateChange(e: string): void {
    this.errors.birthday = !e;
    this.data.birthday = e ?? '';
    this.validateFields();
  }

  changeNationality($event: string | undefined): void {
    this.nationality = $event ?? '';
    this.data.agentProfileFieldValues =
      this.data.agentProfileFieldValues?.filter(
        (item: { fieldId: number; value: string }) => item.fieldId !== 1,
      ) ?? [];
    if ($event) {
      this.data.agentProfileFieldValues.push({ fieldId: 1, value: $event });
      this.errors.nationality = false;
    } else {
      this.errors.nationality = true;
    }
    this.validateFields();
  }

  changeEducationLevel($event: string | undefined): void {
    this.data.agentProfileFieldValues =
      this.data.agentProfileFieldValues?.filter(
        (item: { fieldId: number; value: string }) => item.fieldId !== 3,
      );
    if ($event) {
      this.data.agentProfileFieldValues?.push({ fieldId: 3, value: $event });
    }
  }

  changeQuantityChilds($event: InputTypes) {
    this.errors.quantityChildren = false;
    this.data.agentProfileFieldValues =
      this.data.agentProfileFieldValues?.filter(
        (item: { fieldId: number; value: string }) => item.fieldId !== 2,
      );
    if ($event) {
      this.errors.quantityChildren = Number($event) < 0 || Number($event) > 20;
      this.data.agentProfileFieldValues?.push({
        fieldId: 2,
        value: $event.toString(),
      });
    }
    this.validateFields();
  }

  formatPhone(type: 'cel' | 'tel'): string {
    let format = '';

    switch (this.NODE) {
      case this.NODE_AR:
        format =
          type == 'cel'
            ? 'Cód. país + Cód. área + número: +54(xx) xxxxxxxx (sin 15)'
            : 'Cód. país + Cód. área + número: +54(xxx) xxxxxxx';
        break;

      case this.NODE_EC:
        format = 'Cód. País + Prefijo + Número: +593 (x) xxxxxxx';
        break;

      case this.NODE_PY:
        format = 'Cód. País + Prefijo + Número: +595 (xx) xxxxxx';
        break;

      case this.NODE_DO:
        format = 'Cód. País + Prefijo + Número: +1 (xxx) xxxxxxx';
        break;
    }

    return format;
  }

  get ubicationPlaceholder(): string {
    if (this.NODE === this.NODE_DO) {
      return 'Ingrese una dirección. Se requiere calle, ciudad, provincia y país';
    }

    if (this.NODE === this.NODE_GLOBAL) {
      return 'Ingrese una dirección. Se requiere calle, número, código postal, ciudad, provincia y país';
    }

    return 'Ingrese una dirección';
  }
}
